// material-ui
import { Typography } from "@mui/material";
import { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
// project imports
import NavGroup from "./NavGroup";
import getDashboard from "menu-items/dashboard";
import { getUtilities } from "menu-items/utilities";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const { t } = useTranslation();
  const [menuItems, setMenuItems] = useState([]);

  console.log(menuItems);

  useEffect(() => {
    setMenuItems([getDashboard(t), ...getUtilities(t)]);
  }, [t]);


  // Optional: listen to localStorage changes from login/logout in other tabs
  useEffect(() => {
    const handleStorageChange = () => {
      setMenuItems([getDashboard(t), getUtilities(t)]);
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [t]);

  const userType = localStorage.getItem("userType");

  const navItems = menuItems.filter((item) => !((userType !== "Admin" && userType !== "SubAdmin") && item.id === "dashboard")).map((item) => {
    switch (item.type) {
      case "group":
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
